var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.1287H17M13 9.12866V17.1287M1 13.1287C1 14.7045 1.31039 16.265 1.91345 17.7209C2.5165 19.1768 3.40042 20.4996 4.51472 21.6139C5.62902 22.7282 6.95189 23.6122 8.4078 24.2152C9.86371 24.8183 11.4241 25.1287 13 25.1287C14.5759 25.1287 16.1363 24.8183 17.5922 24.2152C19.0481 23.6122 20.371 22.7282 21.4853 21.6139C22.5996 20.4996 23.4835 19.1768 24.0866 17.7209C24.6896 16.265 25 14.7045 25 13.1287C25 11.5528 24.6896 9.99237 24.0866 8.53646C23.4835 7.08055 22.5996 5.75768 21.4853 4.64338C20.371 3.52908 19.0481 2.64516 17.5922 2.04211C16.1363 1.43905 14.5759 1.12866 13 1.12866C11.4241 1.12866 9.86371 1.43905 8.4078 2.04211C6.95189 2.64516 5.62902 3.52908 4.51472 4.64338C3.40042 5.75768 2.5165 7.08055 1.91345 8.53646C1.31039 9.99237 1 11.5528 1 13.1287Z",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandPlus);
export default __webpack_public_path__ + "static/media/expand-plus.fcc485c1832589607bccbd40b366f717.svg";
export { ForwardRef as ReactComponent };